"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postUpdateMultipleResult = exports.postUpdateResult = exports.getApplications = exports.getApplicationById = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getApplicationById = function (_a) {
    var applicationId = _a.applicationId;
    return core_1.default.get({
        url: "/applications/".concat(applicationId),
    });
};
exports.getApplicationById = getApplicationById;
var getApplications = function (params) {
    return core_1.default.get({
        url: '/applications',
        params: params,
    });
};
exports.getApplications = getApplications;
var postUpdateResult = function (_a) {
    var applicationId = _a.applicationId, applicationResultStatus = _a.applicationResultStatus, interviewEndedAt = _a.interviewEndedAt, interviewStartedAt = _a.interviewStartedAt;
    return core_1.default.post({
        url: "/applications/".concat(applicationId, "/update-result"),
        data: {
            applicationResultStatus: applicationResultStatus,
            interviewEndedAt: interviewEndedAt,
            interviewStartedAt: interviewStartedAt,
        },
    });
};
exports.postUpdateResult = postUpdateResult;
var postUpdateMultipleResult = function (_a) {
    var applicationIds = _a.applicationIds, applicationResultStatus = _a.applicationResultStatus;
    return core_1.default.post({
        url: "/applications/update-result",
        data: {
            applicationResultStatus: applicationResultStatus,
            applicationIds: applicationIds,
        },
    });
};
exports.postUpdateMultipleResult = postUpdateMultipleResult;
